<template>
	<div class="template-messages-list">
		<div class="buttons">
			<vs-button @click="activePrompt = true" color="success"> {{ $t('add') }} </vs-button>
		</div>
		<vx-card class="my-8">
			<div class="tab-text ">
				<vs-table max-items="10" pagination :data="works">
					<template slot="thead">
						<vs-th v-for="fil in field" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr"  v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'name'" >
										{{ tr.name }}
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'client.username'">
									<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
									<router-link to="/">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'author.username'">
									<router-link v-if="tr[fil.field]" :to="'client/' + deepFind(tr, 'author.id')">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'chat_messages_count'">
											<span
												class="counter"
												:class="{ warn: tr.is_chat_unread }"
											>
												{{ tr.chat_messages_count }}
											</span>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'subject'">
									{{
										subjects.find((obj) => {
											return obj.id === tr.subject;
										}).name
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'work_type'">
									{{
										works.find((obj) => {
											return obj.id === tr.work_type;
										}).name
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'quality_level'">
									{{
										levels.find((obj) => {
											return obj.id === tr.quality_level;
										}).name
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'task'">
									<span class="task" v-if="tr[fil.field]">{{tr[fil.field].date_time | moment('DD.MM.YYYY')}}</span>
									<span class="task" @click="idOrder = tr.id;activePrompt = true" v-else>+</span>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'price'">
									{{ tr[fil.field] }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'is_enabled_for_junior'">
									{{ tr[fil.field] ? $t('yes') : $t('no') }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'actions'">
									<div class="flex justify-center">
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="editModel = JSON.parse(JSON.stringify(tr));activePromptEdit = true"
											icon="edit"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-button>
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click='editModel = tr;$vs.dialog({
												color: "danger",
												title: $t("confirmDeletion"),
												acceptText: $t("delete"),
												text: $t("doYouWantToDelete") + " \"" + tr.name + "\"",
												accept: removeTask,
											});'
											icon="edit"
										>
											<feather-icon icon="Trash2Icon"></feather-icon>
										</vs-button>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="tr[fil.field]">
									<div v-html="short(tr[fil.field], 150)">
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>

						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="editTask"
			:active.sync="activePromptEdit"
			:title="$t('changeTemplateAnswer')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt mb-4">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.name"
						name="name"
						v-validate="'required|min:3'"
					/>
				</div>
				<span class="text-danger text-sm">{{ errors.first("name") }}</span>
			</div>
			<div class="con-exemple-prompt mb-3">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('responseText') }}</label>
					<div class="vs-con-input"></div>
					<!-- <vs-textarea
						v-model="editModel.message"
						name="message"
						v-validate="'required|min:3'"
						class="textarea-no-resize mb-0"
						rows="12"
					/> -->

					<vue-editor v-model="editModel.message" />

				</div>
				<span class="text-danger text-sm">{{ errors.first("message") }}</span>
			</div>
		</vs-prompt>
		<vs-prompt
			@cancel="date = ''"
			@accept="createTask"
			:active.sync="activePrompt"
			:title="$t('addAnswer')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt mb-4">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="nameRu"
						name="name"
						v-validate="'required|min:3'"
					/>
				</div>
				<span class="text-danger text-sm">{{ errors.first("name") }}</span>
			</div>
			<div class="con-exemple-prompt mb-3">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('responseText') }}</label>
					<div class="vs-con-input"></div>
					<!-- <vs-textarea
						v-model="message"
						name="message"
						v-validate="'required|min:3'"
						class="textarea-no-resize mb-0"
						rows="12"
					/> -->

					<vue-editor v-model="message" />

				</div>
				<span class="text-danger text-sm">{{ errors.first("message") }}</span>
			</div>

		</vs-prompt>
	</div>
</template>

<script>
import notifier from '../mixins/notifier';
import { VueEditor } from "vue2-editor";

export default {
	name: "typeWorks",
	mixins: [notifier],
	data() {
		return {
			nameRu: '',
			message: '',

			activePrompt: false,
			activePromptEdit: false,
			popupActiv: false,
			subjects: [],
			works: [],
			editModel: {}
		};
	},
    components: {
        VueEditor,
    },
	methods: {
		short: (str, maxlen) => str.length <= maxlen ? str : str.slice(0, maxlen) + ' ...',
		async removeTask(){
			try {

				await this.$http.post("/admin/chat-reply-template/delete/"+this.editModel.id);

				this.notifySuccess(this.$t('deletedSuccessfully'))
				this.editModel = {};
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async editTask(id) {
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return this.activePromptEdit = true;
				let formData = {
					"name": this.editModel.name,
					"message": this.editModel.message,
				}
				await this.$http.post("/admin/chat-reply-template/update/"+this.editModel.id,formData);

				this.notifySuccess(this.$t('changedSuccessfully'));
				this.editModel = {};
				this.activePromptEdit = false;
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async createTask(id) {
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return this.activePrompt = true;
				let formData = {
					"name": this.nameRu,
					"message": this.message,
				}
				await this.$http.post("/admin/chat-reply-template/create",formData);

				this.notifySuccess(this.$t('exchange.acceptText'));
				this.nameRu = "";
				this.message = "";
				this.popupActiv = false;
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getWorks() {
			try {
				this.works = (
					await this.$http.get("/admin/chat-reply-template")).data.data;
			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}
		},
	},
	created() {
		this.field = [
			{
				field: "name",
				title: this.$t('name'),
				width: '20%',
			},
			{
				field: "message",
				title: this.$t('responseText'),
				width: '70%',
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: 'center',
				width: '10%',
			},
		];
	},
	async mounted() {
		this.getWorks();
		// this.tasks = (await this.$http.get("/"+this.$store.state.auth.role+"/task")).data.data;

		// this.levels = (
		// 	await this.$http.get("/settings/get-quality-levels")
		// ).data.data;
		// this.works = (await this.$http.get("/settings/get-work-types")).data.data;
		// this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;
		// this.tabs.forEach((item) => {
		// 	this.getTickets(item.key);
		// });
	},
};
</script>

<style scoped lang="scss">
@import "../assets/scss/vuexy/variables.scss";
@import "../assets/scss/vuexy/functions.scss";
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.inputInTable {
	border: 0;
	resize: none;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.buttons {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	@media screen and (max-width: 375px) {
		button {
			margin: 5px 0;
		}
	}
}
.justify-center .vs-table-text{
	justify-content: center;
}
.vs-checkbox-default{
	flex-shrink: 0;
}
.vs-tabs--content {
	padding: 0;
	margin-top: 10px;
}

.vs-con-table .vs-con-tbody {
	border: 0;
	background-color: transparent;
}
.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}

.vs-table {
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}
.con-vs-tabs .con-slot-tabs{
	overflow: visible;
}
.task {
	background-color: #3ac47d;
	border-radius: 10px;
	padding: 4px 10px;
	color: white;
}
.counter {
	display: inline-block;
	padding: 5px;
	border-radius: 100%;
	font-weight: 600;
	width: 20px;
	height: 20px;
	font-size: 0.7rem;
	border: 1px solid #cfcfcf;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	&.warn {
		background-color: #f0ad4e;
		color: white;
		border-color: #f0ad4e;
	}
}
.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}
	.vs-popup--content {
		padding: 0;
	}
	table {
		width: 100%;
		td {
			padding-bottom: 4px;
		}
	}
	.body {
		padding: 1rem;
		table {
			margin-left: -2px;
		}
		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}
	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;
		button {
			margin-left: 10px;
		}
	}
}
.filter {
	border-bottom: 1px solid #e5e5e5;
	padding-bottom: 1rem;
	padding-top: 0.5rem;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	.date {
		display: flex;
		align-items: center;
	}
	.vx-input-group .vx-input-group-default .vs-input {
		width: 150px;
	}
	.vx-input-group {
		margin-right: 20px;
	}
	.search .vs-icon {
		height: 100%;
		width: 35px;
		background: $primary;
		position: absolute;
		top: 0;
		right: 0;
		color: white !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		font-size: 22px;
	}
	.search .vs-con-input-label {
		width: 270px;
	}
}
.template-messages-list {
	.buttons {
		justify-content: flex-end;
	}
	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}
}
.con-vs-dialog .vs-dialog  {
	width: 100% !important;
	max-width: 800px !important;
}
.set-ticket-done__controls {
	text-align: right;
}
.tox {
	z-index: 999992 !important;
}
.tox-tiered-menu{
	z-index: 999993 !important;
}
.tox-menu {
	z-index: 999994 !important;
}

</style>
